module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-apparel-medium-b8c63a3c27178c3c551ba98f1421d5de.jpg";